<p>Producer & occasional co-host, 2020-2022</p>
<p>A weekly podcast on climate change solutions</p>
<app-project-gallery [galleryItems]="galleryItems"></app-project-gallery>
